import {
  FaFacebookMessenger,
  FaFacebookSquare,
  FaInstagram,
  FaMapMarkerAlt,
  FaPhoneAlt,
} from 'react-icons/fa';

export const navLinks = [
  { name: 'Home', path: '/' },
  { name: 'Karl', path: '/karl' },
  { name: 'Crissy', path: '/crissy' },
  { name: 'Mark', path: '/mark' },
  { name: 'Contact', path: '/contact' },
];

export const socialLinks = [
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/darksidetattooschester',
    icon: FaFacebookSquare,
  },
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/darkside.tattoo.studio/',
    icon: FaInstagram,
  },
  {
    label: 'Messenger',
    href: 'https://www.facebook.com/darksidetattooschester',
    icon: FaFacebookMessenger,
  },
];

export const contactCards = [
  {
    title: 'Visit Studio',
    text: '23A North Burns, Chester-Le-Street, DH3 3TF',
    href: 'https://maps.app.goo.gl/wHjeHwzjrx3HLn2c9',
    icon: FaMapMarkerAlt,
  },
  {
    title: 'Call',
    text: '0191 447 4970',
    href: 'tel:01914474970',
    icon: FaPhoneAlt,
  },
  {
    title: 'Message',
    text: 'Start a Messenger chat',
    href: 'https://www.facebook.com/darksidetattooschester/',
    icon: FaFacebookMessenger,
  },
];

export const studioPillars = [
  {
    title: 'Custom-First Work',
    description:
      'Every tattoo starts with your story and ends with a piece that fits your body and style.',
  },
  {
    title: 'Experienced Artists',
    description:
      'Specialists across multiple styles, from fine line and black & grey to bold colour and traditional.',
  },
  {
    title: 'Clear Booking Process',
    description:
      'Fast consultation replies, transparent pricing guidance, and aftercare support for local and travelling clients.',
  },
];

export const footerSections = [
  {
    title: 'Explore',
    links: [
      { label: 'Home', href: '/' },
      { label: 'Karl Portfolio', href: '/karl' },
      { label: 'Crissy Portfolio', href: '/crissy' },
      { label: 'Mark Portfolio', href: '/mark' },
      { label: 'Contact', href: '/contact' },
    ],
  },
  {
    title: 'Social',
    links: socialLinks.map((item) => ({
      label: item.label,
      href: item.href,
      icon: item.icon,
      external: true,
    })),
  },
  {
    title: 'Studio Info',
    links: [
      {
        label: '23A North Burns, Chester-Le-Street, DH3 3TF',
        href: 'https://maps.app.goo.gl/wHjeHwzjrx3HLn2c9',
        external: true,
      },
      { label: '0191 447 4970', href: 'tel:01914474970' },
      {
        label: 'Mon - Sat: 10:00 - 17:00',
      },
      { label: 'Sun: Closed' },
    ],
  },
];
